import DeltaWifiFeaturedVenueCard from './DeltaWifiFeaturedVenueCard';

export default DeltaWifiFeaturedVenueCard;
